export const highlightedPestList = [
  {
    commonName: "Beech leaf disease",
    scientificName: "Litylenchus crenatae mccannii",
    origin: "Exotic",
    category: "Disease",
    region: "Eastern, Southern",
    learnMoreLink:
      "/map/?state=All%20States&tree=American%20beech&pest=beech%20leaf%20disease",
    pestImageURL: "/images/25092-c-WEB.jpg",
    pestImageDescription:
      "Beech tree leaves turning yellow from beech leaf disease damage",
  },
  {
    commonName: "Southern pine beetle",
    scientificName: "Dendroctonus adjunctus",
    origin: "Native",
    category: "Bark Beetles",
    region: "Southern, Eastern",
    learnMoreLink:
      "/map/?state=All%20States&tree=pine%20spp.&pest=southern%20pine%20beetle",
    pestImageURL: "/images/11003-a-WEB.jpg",
    pestImageDescription: "Close up of a black beetle burrowing into wood",
  },
  {
    commonName: "Emerald ash borer",
    scientificName: "Agrilus planipennis",
    origin: "Exotic",
    category: "Wood Borer",
    region: "Eastern, Southern, Rocky Mountain, Pacific Northwest",
    learnMoreLink:
      "/map/?state=All%20States&tree=ash%20spp.&pest=emerald%20ash%20borer",
    pestImageURL: "/images/15087-a-WEB.jpg",
    pestImageDescription: "Close up of an iridescent green and black insect",
  },
  {
    commonName: "Rapid ohi'a death",
    scientificName: "Ceratocystis spp.",
    origin: "Exotic",
    category: "Disease",
    region: "Pacific",
    learnMoreLink:
      "/map/?state=Hawaii&tree=ohia%20spp.&pest=ohia%2Fguava%20rust",
    pestImageURL: "/images/24034-a-WEB.jpg",
    pestImageDescription:
      "Aerial view of a forest with a patch of ohi'a trees that have died",
  },
  {
    commonName: "Fir engraver",
    scientificName: "Scolytus ventralis",
    origin: "Native",
    category: "Bark Beetles",
    region:
      "Pacific Northwest, Pacific Southwest, Intermountain, Northern, Rocky Mountain, Southwest",
    learnMoreLink:
      "/map/?state=All%20States&tree=fir%20spp.&pest=fir%20engraver",
    pestImageURL: "/images/11050-c-WEB.jpg",
    pestImageDescription: "Close up of a black insect",
  },
  {
    commonName: "Spongy moth",
    scientificName: "Lymantria dispar dispar",
    origin: "Exotic",
    category: "Defoliator",
    region: "Eastern, Southern",
    learnMoreLink:
      "/map/?state=All%20States&tree=oak%20spp.&pest=spongy%20moth",
    pestImageURL: "/images/12089-b-WEB.jpg",
    pestImageDescription:
      "Close up of three beige moths with brown speckles against tree bark",
  },
  {
    commonName: "White pine blister rust",
    scientificName: "Cronartium ribicola",
    origin: "Exotic",
    category: "Disease",
    region:
      "Rocky Mountain, Intermountain, Northern, Pacific Northwest, Pacific Southwest, Southwest, Eastern",
    learnMoreLink:
      "/map/?state=All%20States&tree=pine%20spp.&pest=white%20pine%20blister%20rust",
    pestImageURL: "/images/26001-c-WEB.jpg",
    pestImageDescription:
      "Close up of a white pine branch showing white blisters on the bark",
  },
];

export default highlightedPestList;
